import {
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	CORE_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import {
	BOARDS_ITEM_TYPE as FAVOURITE_BOARDS_ITEM_TYPE,
	PROJECTS_ITEM_TYPE as FAVOURITE_PROJECTS_ITEM_TYPE,
	DASHBOARDS_ITEM_TYPE as FAVOURITE_DASHBOARDS_ITEM_TYPE,
	ISSUES_ITEM_TYPE as FAVOURITE_ISSUES_ITEM_TYPE,
	FILTERS_ITEM_TYPE as FAVOURITE_FILTERS_ITEM_TYPE,
	QUEUES_ITEM_TYPE as FAVOURITE_QUEUES_ITEM_TYPE,
	PLANS_ITEM_TYPE as FAVOURITE_PLANS_ITEM_TYPE,
} from '@atlassian/jira-favourite-change-provider/src/model/constants.tsx';
import type { ItemType as FavouriteItemType } from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import type { IntlShape } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import {
	BOARDS_ITEM_TYPE,
	FILTERS_ITEM_TYPE,
	DASHBOARDS_ITEM_TYPE,
	ISSUES_ITEM_TYPE,
	PROJECTS_ITEM_TYPE,
	QUEUES_ITEM_TYPE,
	PLANS_ITEM_TYPE,
	type ItemType,
} from '../../../constants/item-types.tsx';
import type { Item as ItemData } from '../../../types/item.tsx';
import messages from './messages.tsx';

export const convertToFavouriteItemType = (t: ItemType | string): FavouriteItemType => {
	switch (t) {
		case BOARDS_ITEM_TYPE:
			return FAVOURITE_BOARDS_ITEM_TYPE;
		case PROJECTS_ITEM_TYPE:
			return FAVOURITE_PROJECTS_ITEM_TYPE;
		case DASHBOARDS_ITEM_TYPE:
			return FAVOURITE_DASHBOARDS_ITEM_TYPE;
		case ISSUES_ITEM_TYPE:
			return FAVOURITE_ISSUES_ITEM_TYPE;
		case FILTERS_ITEM_TYPE:
			return FAVOURITE_FILTERS_ITEM_TYPE;
		case QUEUES_ITEM_TYPE:
			return FAVOURITE_QUEUES_ITEM_TYPE;
		case PLANS_ITEM_TYPE:
			return FAVOURITE_PLANS_ITEM_TYPE;
		default:
			return FAVOURITE_ISSUES_ITEM_TYPE;
	}
};

export const getProjectType = (item: ItemData, intl: IntlShape): string => {
	let subtitle = '';
	if (typeof subtitle === 'string') {
		const projectType =
			item.attributes?.projectType !== undefined ? item.attributes.projectType : '';
		if (item.attributes && item.attributes.nextgen === 'true') {
			if (projectType === SOFTWARE_PROJECT || projectType === PRODUCT_DISCOVERY_PROJECT) {
				subtitle = intl.formatMessage(messages.teamManagedSoftware);
			} else if (projectType === SERVICE_DESK_PROJECT) {
				subtitle = intl.formatMessage(messages.teamManagedServiceManagement);
			} else if (projectType === CORE_PROJECT) {
				subtitle = intl.formatMessage(messages.teamManagedBusiness);
			}
		} else if (item.attributes && item.attributes.nextgen === 'false') {
			if (projectType === SOFTWARE_PROJECT) {
				subtitle = intl.formatMessage(messages.companyManagedSoftware);
			} else if (projectType === SERVICE_DESK_PROJECT) {
				subtitle = intl.formatMessage(messages.companyManagedServiceManagement);
			} else if (projectType === CORE_PROJECT) {
				subtitle = intl.formatMessage(messages.companyManagedBusiness);
			} else if (projectType === CUSTOMER_SERVICE_PROJECT && fg('csm_rename_jcs_to_csm')) {
				subtitle = intl.formatMessage(messages.companyManagedCustomerServiceManagement);
			}
		}
	}
	return subtitle;
};
